<ng-container *ngIf="this.selectedTab === 0">
  <p><b>Informatie over het object van onderzoek</b></p>

  <form [formGroup]="objectOfExaminationNatureDescriptionFg">
    <label for="objectOfExaminationNatureDescription" class="form-label">
      Beschrijving van de aard van het object van onderzoek
    </label>
    <div>
      <snelstart-ui-textarea-form-control formControlName="value"
                                          id="objectOfExaminationNatureDescription"
                                          class="me-1 custom-input-800"
                                          (change)="this.saveForm()"
                                          [rows]="2"
      >
      </snelstart-ui-textarea-form-control>
    </div>
  </form>

  <form [formGroup]="objectOfExaminationPeriodStartDateFg">
    <label for="objectOfExaminationPeriodStartDate" class="form-label">
      Startdatum van de periode van het object van onderzoek
    </label>
    <div>
      <snelstart-ui-date-form-control formControlName="value"
                                      id="objectOfExaminationPeriodStartDate"
                                      label=""
                                      class="me-1 custom-input-250"
                                      (change)="saveForm()"
      >
      </snelstart-ui-date-form-control>
    </div>
  </form>

  <form [formGroup]="objectOfExaminationPeriodEndDateFg">
    <label for="objectOfExaminationPeriodEndDate" class="form-label">
      Einddatum van de periode van het object van onderzoek
    </label>
    <div>
      <snelstart-ui-date-form-control formControlName="value"
                                      id="objectOfExaminationPeriodEndDate"
                                      label=""
                                      class="me-1 custom-input-250"
                                      (change)="saveForm()"
      >
      </snelstart-ui-date-form-control>
    </div>
  </form>

  <form [formGroup]="objectOfExaminationResponsibleOrganisationDescriptionFg">
    <label for="objectOfExaminationResponsibleOrganisationDescription" class="form-label">
      Beschrijving van de verantwoordelijke entiteit van het object van onderzoek
    </label>
    <div>
      <snelstart-ui-textarea-form-control formControlName="value"
                                          id="objectOfExaminationResponsibleOrganisationDescription"
                                          class="me-1 custom-input-800"
                                          (change)="this.saveForm()"
                                          [rows]="2"

      >
      </snelstart-ui-textarea-form-control>
    </div>
  </form>

  <div>
    <p><b>Overige informatie</b></p>
  </div>

  <form [formGroup]="engagementTypeFg">
    <snelstart-ui-text-form-control formControlName="value"
                                    id="engagementType"
                                    label="Soort opdracht"
                                    class="me-1 custom-input-250 custom-readonly"
                                    (change)="this.saveForm()"
    >
    </snelstart-ui-text-form-control>
  </form>

  <form [formGroup]="internalReferenceFg">
    <snelstart-ui-text-form-control formControlName="value"
                                    id="internalReference"
                                    label="Interne referentie"
                                    class="me-1 custom-input-250"
                                    (change)="this.saveForm()"
    >
    </snelstart-ui-text-form-control>
  </form>

  <form [formGroup]="entityIdentificationTypeFg">
    <snelstart-ui-text-form-control formControlName="value"
                                    id="entityIdentificationType"
                                    label="Type identificatie van de entiteit"
                                    class="me-1 custom-input-250 custom-readonly"
                                    (change)="this.saveForm()"
    >
    </snelstart-ui-text-form-control>
  </form>

  <form [formGroup]="entityIdentificationFg">
    <snelstart-ui-text-form-control formControlName="value"
                                    id="entityIdentification"
                                    label="Identificatie van de entiteit"
                                    class="me-1 custom-input-250"
                                    (change)="this.saveForm()"
    >
    </snelstart-ui-text-form-control>
  </form>
</ng-container>

<ng-container *ngIf="this.selectedTab === 1">

  <form [formGroup]="auditorsReportHeaderFg">
    <div class="row align-items-center">
      <snelstart-ui-text-form-control formControlName="value"
                                      id="auditorsReportHeader"
                                      label="Koptekst verklaring van de accountant"
                                      class="me-1 custom-input-800"
                                      (change)="this.saveForm()"
      >
      </snelstart-ui-text-form-control>
      <div class="col-auto" style="width: 48px;"></div>
    </div>
  </form>

  <form [formGroup]="addresseeFg">
    <div class="row">
      <snelstart-ui-text-form-control formControlName="value"
                                      id="addressee"
                                      label="Geadresseerde"
                                      class="me-1 custom-input-800"
                                      (change)="this.saveForm()"
      >
      </snelstart-ui-text-form-control>
      <div class="col-auto" style="width: 48px;"></div>
    </div>
  </form>

  <form [formGroup]="introductoryParagraphFg">
    <div class="row">
      <snelstart-ui-textarea-form-control formControlName="value"
                                          id="introductoryParagraph"
                                          label="Inleidende paragraaf"
                                          class="me-1 custom-input-800"
                                          (change)="this.saveForm()"
                                          [rows]="7"
      >
      </snelstart-ui-textarea-form-control>
      <div class="col-auto" style="width: 48px;"></div>
    </div>
  </form>

  <form [formGroup]="responsibilityTitleFg">
    <label for="responsibilityTitle" class="form-label">
      Titel voor de verantwoordelijkheden van het object van onderzoek
    </label>
    <div class="row">
      <snelstart-ui-text-form-control formControlName="value"
                                      id="responsibilityTitle"
                                      class="me-1 custom-input-800"
                                      (change)="this.saveForm()"
      >
      </snelstart-ui-text-form-control>
      <div class="col-auto" style="width: 48px;"></div>
    </div>
  </form>

  <form [formGroup]="managementsResponsibilityFg">
    <label for="managementsResponsibility" class="form-label">
      Verantwoordelijkheid van het bestuur
    </label>
    <ng-container formArrayName="managementsResponsibilities">
      @for (item of managementsResponsibilities.controls; track item; let i = $index) {
        <ng-container [formGroupName]="i">
          <div class="row flex-nowrap align-items-center">
            <ng-container formGroupName="managementsResponsibility">
              <snelstart-ui-textarea-form-control formControlName="value"
                                                  id="managementsResponsibility"
                                                  [required]=true
                                                  class="me-1 custom-input-800"
                                                  (change)="this.saveForm()"
                                                  [rows]="5"
              >
              </snelstart-ui-textarea-form-control>
            </ng-container>
            <div class="col-auto mb-2">
              <snelstart-ui-button
                (click)="verwijderRijManagementsResponsibilities(i)"
                icon="trash"
                iconType="light"
                id="buttonDelete"
                size="medium"
                type="secondary"
              >
              </snelstart-ui-button>
            </div>
          </div>
        </ng-container>
      }
    </ng-container>

    <div>
      <snelstart-ui-button id="addE" class="snelstart-ui-button pb-0" type="link" icon="plus"
                           (click)="addRijManagementsResponsibilities()">Item toevoegen
      </snelstart-ui-button>
    </div>
  </form>
  <hr>
  <form [formGroup]="professionalAccountantsResponsibilityFg">
    <label for="professionalAccountantsResponsibility" class="form-label">
      Verantwoordelijkheid van de accountant
    </label>
    <ng-container formArrayName="professionalAccountantsResponsibilities">
      @for (item of professionalAccountantsResponsibilities.controls; track item; let i = $index) {
        <ng-container [formGroupName]="i">
          <div class="row flex-nowrap align-items-center">
            <ng-container formGroupName="professionalAccountantsResponsibility">
              <snelstart-ui-textarea-form-control formControlName="value"
                                                  id="professionalAccountantsResponsibility"
                                                  [required]=true
                                                  class="me-1 custom-input-800"
                                                  (change)="this.saveForm()"
                                                  [rows]="3"
              >
              </snelstart-ui-textarea-form-control>
            </ng-container>
            <div class="col-auto mb-2">
              <snelstart-ui-button
                (click)="verwijderRijProfessionalAccountantsResponsibilities(i)"
                icon="trash"
                iconType="light"
                id="buttonDelete"
                size="medium"
                type="secondary"
              >
              </snelstart-ui-button>
            </div>
          </div>
        </ng-container>
      }
    </ng-container>
    <div>
      <snelstart-ui-button id="addE" class="snelstart-ui-button pb-0" type="link" icon="plus"
                           (click)="addRijProfessionalAccountantsResponsibilities()">Item toevoegen
      </snelstart-ui-button>
    </div>
  </form>
  <hr>

  <form [formGroup]="reportingTitleFg">
    <label for="reportingTitle" class="form-label">
      Titel voor het object van onderzoek en basis voor het oordeel
    </label>
    <div class="row">
      <snelstart-ui-text-form-control formControlName="value"
                                      id="reportingTitle"
                                      class="me-1 custom-input-800"
                                      (change)="this.saveForm()"
      >
      </snelstart-ui-text-form-control>
      <div class="col-auto" style="width: 48px;"></div>
    </div>
  </form>

  <form [formGroup]="emphasisOfMatterUncertaintyAboutGoingConcernFg">
    <label for="emphasisOfMatterUncertaintyAboutGoingConcern" class="form-label">
      Benadrukking van aangelegenheden onzekerheid over de continuïteit
    </label>
    <div class="row">
      <snelstart-ui-textarea-form-control formControlName="value"
                                          id="emphasisOfMatterUncertaintyAboutGoingConcern"
                                          class="me-1 custom-input-800"
                                          (change)="this.saveForm()"
                                          [rows]="3"
      >
      </snelstart-ui-textarea-form-control>
      <div class="col-auto" style="width: 48px;"></div>
    </div>
  </form>

  <form [formGroup]="emphasisOfMatterFg">
    <label for="emphasisOfMatter" class="form-label">
      Benadrukking van aangelegenheden
    </label>
    <ng-container formArrayName="emphasisOfMatters">
      @for (item of emphasisOfMatters.controls; track item; let i = $index) {
        <ng-container [formGroupName]="i">
          <div class="row flex-nowrap align-items-center">
            <ng-container formGroupName="emphasisOfMatter">
              <snelstart-ui-textarea-form-control formControlName="value"
                                                  id="emphasisOfMatter"
                                                  [required]=true
                                                  class="me-1 custom-input-800"
                                                  (change)="this.saveForm()"
                                                  [rows]="3"
              >
              </snelstart-ui-textarea-form-control>
            </ng-container>
            <div class="col-auto mb-2">
              <snelstart-ui-button
                (click)="verwijderRijEmphasisOfMatters(i)"
                icon="trash"
                iconType="light"
                id="buttonDelete"
                size="medium"
                type="secondary"
              >
              </snelstart-ui-button>
            </div>
          </div>
        </ng-container>
      }
    </ng-container>
    <div>
      <snelstart-ui-button id="addE" class="snelstart-ui-button pb-0" type="link" icon="plus"
                           (click)="addRijEmphasisOfMatters()">Item toevoegen
      </snelstart-ui-button>
    </div>
  </form>
  <hr>

  <form [formGroup]="otherMatterFg">
    <label for="otherMatter" class="form-label">
      Toelichtende paragraaf
    </label>
    <ng-container formArrayName="otherMatters">
      @for (item of otherMatters.controls; track item; let i = $index) {
        <ng-container [formGroupName]="i">
          <div class="row flex-nowrap align-items-center">
            <ng-container formGroupName="otherMatter">
              <snelstart-ui-textarea-form-control formControlName="value"
                                                  id="otherMatter"
                                                  [required]=true
                                                  class="me-1 custom-input-800"
                                                  (change)="this.saveForm()"
                                                  [rows]="3"
              >
              </snelstart-ui-textarea-form-control>
            </ng-container>
            <div class="col-auto mb-2">
              <snelstart-ui-button
                (click)="verwijderRijOtherMatters(i)"
                icon="trash"
                iconType="light"
                id="buttonDelete"
                size="medium"
                type="secondary"
              >
              </snelstart-ui-button>
            </div>
          </div>
        </ng-container>
      }
    </ng-container>
    <div>
      <snelstart-ui-button id="addO" class="snelstart-ui-button pb-0" type="link" icon="plus"
                           (click)="addRijOtherMatters()">Item toevoegen
      </snelstart-ui-button>
    </div>
  </form>

</ng-container>

<ng-container *ngIf="this.selectedTab === 2">
  <form [formGroup]="handtekeningAccountantsFg">
    <ng-container formArrayName="handtekeningAccountants">
      @for (item of handtekeningAccountants.controls; track item; let i = $index) {
        <ng-container [formGroupName]="i">
          <div class="row flex-nowrap">
            <ng-container formGroupName="professionalAccountantName">
              <snelstart-ui-text-form-control formControlName="value"
                                              [label]="i === 0 ? 'Naam accountant' : ''"
                                              id="professionalAccountantName"
                                              [required]=true
                                              class="me-1 custom-input-250"
                                              (change)="this.saveForm()"
              >
              </snelstart-ui-text-form-control>
            </ng-container>
            <ng-container formGroupName="professionalAccountantAddress">
              <snelstart-ui-text-form-control formControlName="value"
                                              [label]="i === 0 ? 'Vestigingsplaats accountant' : ''"
                                              id="professionalAccountantAddress"
                                              [required]=true
                                              class="me-1 custom-input-250"
                                              (change)="this.saveForm()"
              >
              </snelstart-ui-text-form-control>
            </ng-container>
            <ng-container formGroupName="dateOfReport">
              <snelstart-ui-date-form-control formControlName="value"
                                              [label]="i === 0 ? 'Datum verklaring' : ''"
                                              id="dateOfReport"
                                              [required]=true
                                              class="me-1 custom-input-250"
                                              (change)="this.saveForm()"
              >
              </snelstart-ui-date-form-control>
            </ng-container>
            <ng-container formGroupName="firmName">
              <snelstart-ui-text-form-control formControlName="value"
                                              [label]="i === 0 ? 'Naam accountantspraktijk' : ''"
                                              id="firmName"
                                              [required]=true
                                              class="me-1 custom-input-250"
                                              (change)="this.saveForm()"
              >
              </snelstart-ui-text-form-control>
            </ng-container>
            <div class="col-auto">
              <snelstart-ui-button
                (click)="verwijderRijHandtekeningAccountants(i)"
                [class]="i === 0 ? 'pt-3' : ''"
                icon="trash"
                iconType="light"
                id="buttonDelete"
                size="medium"
                type="secondary"
              >
              </snelstart-ui-button>
            </div>
          </div>
        </ng-container>
      }
    </ng-container>
  </form>

  <div>
    <snelstart-ui-button id="addA" class="snelstart-ui-button pb-0" type="link" icon="plus"
                         (click)="addRijHandtekeningAccountants()">Item toevoegen
    </snelstart-ui-button>
  </div>
</ng-container>
